import { HelperContext } from "../../Helper/helper.context";
import { helpContextResponsive } from "../../Helper/utils";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import ImgHelpCustomDatePicker1 from '../../../images/help_context/calendar_1.png';
import ImgHelpCustomDatePicker2 from '../../../images/help_context/calendar_2.png';

export const CustomDatepickerHelpContext = ({onClose}) => {
    return (
        <HelperContext 
        onClose={onClose}
        children={
            <div className="pos-relative flex-grow-1">
            <Carousel 
                className="help-context-carousel"            
                responsive={helpContextResponsive}
            >
                <div className="help-context-item">
                    <img src={ImgHelpCustomDatePicker1}/>
                </div>
                <div className="help-context-item">
                    <img src={ImgHelpCustomDatePicker2}/>
                </div>
            </Carousel>
        </div>
}
    />    
)}